// extracted by mini-css-extract-plugin
export default {"eventsTable":"styles_events-table_QJdET","pager":"styles_pager_TJ_3s","input":"styles_input_oumye","inputSection":"styles_input-section_Jk8GX","table":"styles_table_kl71Z"};